module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex justify-content-center align-items-center color-6 radius-normal border-color-6 p-2 bg-lightest my-2"
  }, [_c('i', {
    class: ['ico', _vm.icon, 'color-6', 'fs-largest', 'ml-3']
  }), _vm._v(" "), _c('p', {
    class: ['fs-normal', {
      bold: _vm.bold
    }]
  }, [_vm._v(_vm._s(_vm.message))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55744638"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/alertMessage/AlertMessage.vue
// module id = 1302
// module chunks = 0